export default {
    props: {
        width: String,
        height: String,
        maxHeight: String,
        minHeight: String,
        backgroundColor: String,
        shadowColor: String,

        color: String,
        fontSize: String,
        fontWeight: String,
        letterSpacing: {
            type: String,
            default: 'normal',
        },
        alignItems: String,
        justifyContent: String,
    },
    computed: {
        cssStyle() {
            return {
                width: this.width,
                height: this.height,
                'max-height': this.maxHeight,
                'min-height': this.minHeight,
                'box-shadow': `2px 2px 10px 0 ${this.shadowColor}`,
                'background-color': this.backgroundColor,
                color: this.color,
                'font-size': this.fontSize,
                'font-weight': this.fontWeight,
                'letter-spacing': this.letterSpacing,
                'align-items': this.alignItems,
                'justify-content': this.justifyContent,
            };
        },
    },
};
